import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { StatusCode } from '../_shared/_enums/Common';
import { FormConfigModel } from '../_shared/_models/Layout/FormConfig';
import { ChangePasswordDTO } from '../_shared/_models/jobsAndTalents/jobsAndTalentsModels';
import { CommonService } from '@services/app.common.service';

@Component({
    selector: 'app-update-passworduser.component',
    templateUrl: './updatePasswordUser.component.html',
    standalone: false
})
export class UpdatePasswordUserComponent implements OnInit {
  public systemuserid = 0
  public gsystemuserid = '';
  public StatusCode = StatusCode;
  public modalConfig = {} as FormConfigModel;
  public changePasswordDTO = {} as ChangePasswordDTO;

  constructor(private route: ActivatedRoute, public common: CommonService, private renderer: Renderer2) {
    this.renderer.removeClass(document.body, 'body-class');
    this.renderer.addClass(document.body, 'body-class-login');
    this.route.queryParams.subscribe((params: Params) => {
      this.systemuserid = params['systemuserid'];
      this.gsystemuserid = params['gsystemuserid'];
    });
    this.modalConfig.hideDefaultAction = true;
    this.modalConfig.hideCard = false;
  }

  ngOnInit() {
    this.modalConfig.hideDefaultAction = true;
    this.modalConfig.hideCard = false;
    this.changePasswordDTO = {} as ChangePasswordDTO
  }
  ChangePassword() {
    this.changePasswordDTO.systemuserid = this.systemuserid;
    this.changePasswordDTO.userid = this.gsystemuserid;
    if (this.changePasswordDTO.password != this.changePasswordDTO.retypepassword) {
      this.common.Notification.error(this.common.GetTranslation('Messages.passwordMatch'));
    } else {
      this.common.PostData(this.common.ApiUrls.CandidateDetail.ChangePassword, JSON.stringify(this.changePasswordDTO), true).then(data => {
        let result = data;
        if (result.status == this.StatusCode.OK) {
        }
      });
    }
  }
}
